import { render } from "./LinkToRecipientSection.vue?vue&type=template&id=e8c7db1e&scoped=true"
import script from "./LinkToRecipientSection.vue?vue&type=script&lang=js"
export * from "./LinkToRecipientSection.vue?vue&type=script&lang=js"

import "./LinkToRecipientSection.vue?vue&type=style&index=0&id=e8c7db1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c7db1e"],['__file',"src/components/LinkToRecipientSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8c7db1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8c7db1e', __exports__)) {
    api.reload('e8c7db1e', __exports__)
  }
  
  module.hot.accept("./LinkToRecipientSection.vue?vue&type=template&id=e8c7db1e&scoped=true", () => {
    api.rerender('e8c7db1e', render)
  })

}


export default __exports__